export const OpenNavIcon = () => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M4.99999 19L11.6041 12.338C11.7976 12.1428 11.7972 11.828 11.6033 11.6332L4.99999 5'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
    />
    <path
      d='M12.0462 19L18.6503 12.338C18.8438 12.1428 18.8435 11.828 18.6496 11.6332L12.0462 5'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
    />
  </svg>
);
